(function () {
  'use strict';

  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  class MtBestSellers {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-mt-best-sellers-track]');
      this.progressBar = root.querySelector('[data-mt-best-sellers-progress]');
      this.cards = this.track ? Array.from(this.track.children) : [];
      this.destroyed = false;
      this.maxScroll = 0;

      if (!this.track) {
        this.destroyed = true;
        return;
      }

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.dragging = false;
      this.startX = 0;
      this.startScroll = 0;

      this.init();
    }

    init() {
      this.track.querySelectorAll('img').forEach((img) => {
        img.setAttribute('draggable', 'false');
      });

      this.track.addEventListener('pointerdown', this.onPointerDown);
      this.track.addEventListener('click', this.onClick, true);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);

      this.measure();
      this.updateProgress();
    }

    measure() {
      this.maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    onScroll() {
      this.updateProgress();
    }

    onResize() {
      this.measure();
      this.updateProgress();
    }

    updateProgress() {
      if (!this.progressBar || !MOBILE_MQ.matches) return;

      const left = this.track.scrollLeft;
      const max = this.maxScroll || 0;
      const scrollRatio = max <= 0 ? 1 : Math.min(1, Math.max(0, left / max));
      const visibleRatio =
        this.track.scrollWidth > 0 ? this.track.clientWidth / this.track.scrollWidth : 1;
      const cardMin = this.cards.length > 0 ? 100 / this.cards.length : 0.2;
      const minProgress = Math.min(100, Math.max(15, visibleRatio * 100, cardMin));
      const progress = minProgress + scrollRatio * (100 - minProgress);

      this.progressBar.style.width = `${progress}%`;
    }

    onPointerDown(event) {
      if (!MOBILE_MQ.matches) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      this.dragging = false;
      this.startX = event.clientX;
      this.startScroll = this.track.scrollLeft;
      this.moved = false;

      const onMove = (moveEvent) => {
        const delta = moveEvent.clientX - this.startX;
        if (Math.abs(delta) > 6) {
          this.dragging = true;
          this.moved = true;
        }
        if (this.dragging) {
          this.track.scrollLeft = this.startScroll - delta;
          this.updateProgress();
        }
      };

      const onUp = () => {
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        window.removeEventListener('pointercancel', onUp);
        window.setTimeout(() => {
          this.dragging = false;
        }, 0);
      };

      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
      window.addEventListener('pointercancel', onUp);
    }

    onClick(event) {
      if (this.moved) {
        event.preventDefault();
        event.stopPropagation();
        this.moved = false;
      }
    }

    destroy() {
      if (!this.track) return;
      this.track.removeEventListener('pointerdown', this.onPointerDown);
      this.track.removeEventListener('click', this.onClick, true);
      this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.destroyed = true;
    }
  }

  const instances = new Map();

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-mt-best-sellers]').forEach((node) => {
      if (instances.has(node)) return;
      const inst = new MtBestSellers(node);
      if (!inst.destroyed) instances.set(node, inst);
    });
  }

  function destroy(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-mt-best-sellers]').forEach((node) => {
      const inst = instances.get(node);
      if (!inst) return;
      inst.destroy();
      instances.delete(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroy(event.target);
  });
})();
